import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

interface BodyProps extends TypographyProps<'p'> {
  children: React.ReactNode;
  size: BodySize;
}
type BodySize = 'small' | 'smallBold' | 'body' | 'link';

const sizes: Record<BodySize, any> = {
  small: { color: '#1F2428', fontSize: '14px', fontWeight: 400, lineHeight: '21px' },
  smallBold: { color: '#1F2428', fontSize: '14px', fontWeight: 500, lineHeight: '21px' },
  body: { color: '#1F2428', fontSize: '16px', fontWeight: 400, lineHeight: '24px' },
  link: {
    color: '#1E2D73',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    sx: {
      display: 'inline',
      textDecoration: 'underline',
      cursor: 'pointer',
      '&:hover': {
        color: '#483FCD',
        textDecoration: 'none'
      }
    }
  }
};

const Body = ({ children, size, ...props }: BodyProps) => {
  const bodyProps = sizes[size];

  return (
    <Typography {...bodyProps} {...props}>
      {children}
    </Typography>
  );
};

export default Body;
